import { CARELON_DIRECTORY_TRACKING_CONFIG, CARELON_PROVIDER_DIRECTORY_PLACEMENTS } from './constants'
import {
  CARELON_MIXPANEL_BENEFITS,
  CARELON_MIXPANEL_OTHER_TREATMENT,
  INTEGRATED_BENEFITS_MIXPANEL_PROPERTIES,
  INTEGRATED_BENEFITS_SECTION_PROPERTIES,
  S4C_PROPERTIES,
} from '../common/constants/mixpanelConstants'
import { ZeroResultsEnhancementType } from '../providers/constants'

import type {
  CarelonDirectoryClickPropertiesParams,
  CarelonDirectoryViewProperties,
  CarelonDirectoryViewPropertiesParams,
} from './types'

/** Adds Carelon availability to a page view using the same visibility decision as the screen. */
export const getCarelonDirectoryViewProperties = ({
  placement,
  shouldShowCarelonDirectory,
  selectedTreatmentOption,
}: CarelonDirectoryViewPropertiesParams): CarelonDirectoryViewProperties => {
  if (
    shouldShowCarelonDirectory === false ||
    (placement.type === CARELON_PROVIDER_DIRECTORY_PLACEMENTS.CONSOLIDATED_CARE_NAVIGATOR &&
      placement.isZeroProvidersFlow === false) ||
    (placement.type === CARELON_PROVIDER_DIRECTORY_PLACEMENTS.ENHANCED_ZERO_RESULTS &&
      placement.enhancementType === ZeroResultsEnhancementType.NONE)
  ) {
    return {}
  }

  return {
    ...CARELON_DIRECTORY_TRACKING_CONFIG[placement.type].viewProperties,
    [S4C_PROPERTIES.TREATMENT_OPTION]: selectedTreatmentOption,
    [S4C_PROPERTIES.OTHER_TREATMENTS]: CARELON_MIXPANEL_OTHER_TREATMENT,
  }
}

/** Describes where a Carelon link was clicked; callers handle tracking and opening the link. */
export const getCarelonDirectoryClickProperties = (params: CarelonDirectoryClickPropertiesParams) => ({
  ...CARELON_DIRECTORY_TRACKING_CONFIG[params.placement].clickProperties,
  [INTEGRATED_BENEFITS_MIXPANEL_PROPERTIES.BENEFITS]: CARELON_MIXPANEL_BENEFITS,
  [INTEGRATED_BENEFITS_SECTION_PROPERTIES.BENEFITS_DIRECTORY_SECTION]: null,
  ...('selectedTreatmentOption' in params && {
    [S4C_PROPERTIES.TREATMENT_OPTION]: params.selectedTreatmentOption,
  }),
})
